import { render, staticRenderFns } from "./AffiliateFields.vue?vue&type=template&id=15ef507e"
import script from "./AffiliateFields.vue?vue&type=script&lang=js"
export * from "./AffiliateFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports